import driversReducer from "./driversSlice";
import driverReducer from "./driverSlice";

const drivers = {
  drivers: driversReducer,
  driver: driverReducer,
};

export default drivers;
